<template>
  <v-alert type="error" prominent dark dense>
    <p class="title ma-0">{{ message }}</p>
  </v-alert>
</template>

<script>
export default {
  name: "ErrorMessage",
  props: ["message"]
};
</script>